import { ETH_SUPPORTED_TOKENS, TRX_SUPPORTED_TOKENS } from "./envConstants";

export const NETWORK_TOKENS_MAP = {
  ETH: ETH_SUPPORTED_TOKENS,
  TRX: TRX_SUPPORTED_TOKENS,
} as const;

export const getSupportedTokensByNetwork = (network: keyof typeof NETWORK_TOKENS_MAP): string[] => {
  return NETWORK_TOKENS_MAP[network] || [];
};

export const getTokensAsOptions = (network: keyof typeof NETWORK_TOKENS_MAP): Record<string, string> => {
  const tokens = getSupportedTokensByNetwork(network);
  return tokens.reduce(
    (acc, token) => {
      acc[token] = token;
      return acc;
    },
    {} as Record<string, string>
  );
};
